import React, { useState, useEffect } from 'react';
import { StyleSheet, View, Platform } from 'react-native';
import CustomButton from '../components/CustomButton/CustomButton';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useAccount } from '../hooks/useAccount';
import { useSignin } from '../hooks/useSignIn';
import { useAuthContext } from '../hooks/useAuthContext';
import { useTheme } from '@react-navigation/native';
import HomeShortcutPages from "./HomeShortcutsPage/HomeShortcutPages";

// * Language 
import { useTranslation } from 'react-i18next';

const Home = ({ navigation }) => {

  const [isLoading, setIsLoading] = useState(true);
  const { user, clientApi } = useAuthContext();
  const { pendingActivitiesCountGet, leaveAnalysisGet, managerEmployeesGet, oasisParamGet, teamGet } = useAccount();
  const { refreshSignIn } = useSignin();


  const { colors } = useTheme();
  const styles = makeStyles(colors);

  // To be used in a future release with NewsFeed data
  // const [newsFeedData, setNewsFeedData] = useState([]);
  // const [leaveCountData, setLeaveCountData] = useState([]);

  // * This is called from the useeffect and also from on refresh
  // * API call to retrieve the number of pending Leave Application Approvals
  // * Before Refreshing the reducer data get a new Access Token
  const GetLAACount = async () => {
    refreshSignIn(user, clientApi);
    await teamGet().catch(console.error);
    await managerEmployeesGet().catch(console.error);
    await pendingActivitiesCountGet().catch(console.error);
    await leaveAnalysisGet().catch(console.error);
    await oasisParamGet().catch(console.error);
    setIsLoading(false);
  };

  useEffect(() => {
    // Create Async Function 
    const onLAAGet = async () => {
      await GetLAACount()
    }
    // Call Async Function
    onLAAGet()
      // make sure to catch any error
      .catch(console.error);
  }, [])

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <View
          style={styles.row}>
          <CustomButton
            iconName='megaphone-outline'
            onPress={() => { navigation.navigate('HomePageZero') }}
            show='HOME_BELL'
            type='HOME_BELL'
            textTop='2'
            sz={25}
          />
          <CustomButton
            iconName='person-outline'
            onPress={() => { navigation.navigate('MyAccountScreen') }}
            show='HOME_BELL'
            type='HOME_BELL'
            textTop='2'
            sz={25}
          />
        </View >
      ),
    });
  }, [navigation]);

  if (isLoading === true) return null;

  return (
    <SafeAreaView
      style={styles.main}>
      <HomeShortcutPages />
    </SafeAreaView>
  )
};

//* Styles to be used in the class  -- You can also define these inline <Text style= ....> </Text> 
const makeStyles = (colors) => StyleSheet.create({
  main: {
    flex: 1,
    justifyContent: 'flex-start',
    paddingTop: -100,
    paddingBottom: -100,
    // ! LEAVE THIS IF THERE ARE HEIGHT ISSUES THEN BLACK COLOUR WILL SHOW ON THE SCREEN 
    backgroundColor: 'transparent'

  },
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    margin: (Platform.OS === 'web') ? 15 : 0,
  },
});

//* exporting the above function to the applications
export default Home;